import React from 'react'
import {Lang} from 'yougile-lang'
import {AutoTaskCover, DataObjectId, Hub} from 'yougile-model'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {DropdownMultiSelectList} from '@components/common/dropdown-list/dropdown-list'
import {Board} from '@extensions/board'

interface Props {
  setValue: (value: AutoTaskCover) => void
  onClick: () => void
  data?: AutoTaskCover
  label: string
  hintLabel: string
  board: Hub
}

export const AutoTaskCoverCheckbox = (props: Props) => {
  const {setValue, onClick, data, label, hintLabel, board} = props

  const chooseLocation = (values: DataObjectId[]) => {
    setValue({checked: true, values})
  }

  const {values = [], checked} = data || {}

  const columns = Board.listColumns(board, {sorted: true, noMirrors: true})
  const options = columns.map(col => ({label: col.title, value: col.id}))
  const optionsValues = columns.map(col => col.id)

  const filteredValues = values.filter(
    value => checked && optionsValues.includes(value)
  )

  const titles = options
    .filter(opt => checked && filteredValues.includes?.(opt.value))
    .map(({label}) => label)

  return (
    <div className="mb-16">
      <div className="flex gap-8">
        <CheckboxNew
          value={Boolean(checked)}
          onChange={onClick}
          label={label}
          renderFullFootnote
          footnote={
            <div>
              <div>{hintLabel}</div>

              {checked && (
                <div className="mt-8" onClick={e => e.stopPropagation()}>
                  <DropdownMultiSelectList<DataObjectId>
                    className="w-240"
                    value={filteredValues}
                    onChange={chooseLocation}
                    options={options}
                    placeholder={Lang.msg.component.dropdown.all}
                    allText={`${Lang.msg.component.dropdown.selected} ${options.length} ${Lang.msg.component.dropdown.outOf} ${options.length}`}
                    withoutAll
                    large
                  />
                  <div className="w-240 micro-regular text-secondary">
                    {Lang.msg.board.listAndMore(titles)}
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>
    </div>
  )
}
